var map = {
	"./blog.yml": 48,
	"./cloud.yml": 49,
	"./color.yml": 50,
	"./country.yml": 51,
	"./doc.yml": 52,
	"./emoji.yml": 53,
	"./flag.yml": 54,
	"./git.yml": 55,
	"./icon.yml": 56,
	"./license.yml": 57,
	"./link.yml": 58,
	"./people.yml": 59,
	"./soft.yml": 60,
	"./src.yml": 61,
	"./status.yml": 62,
	"./taxonomy.yml": 63
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 47;